export type EmarsysResponse = {
  status: "success" | "error";
  message: string;
  emarsysCode: (typeof emarsysCodes)[number];
};
export const emarsysCodes = [1, 2, 3, 4, 5];
